


























import { Vue, Component } from 'vue-property-decorator'
import TableOfContent from '@/components/TableOfContent.vue'

@Component({
  components: {
    TableOfContent
  }
})
export default class NetatmoHeader extends Vue {
  isBurgerOpen = false
  accessToken = ''

  toggleBurger (): void {
    this.isBurgerOpen = !this.isBurgerOpen
  }

  setAccessToken (): void {
    this.$store.commit('API/SET_ACCESS_TOKEN', this.accessToken)
    this.accessToken = ''
  }
}
